import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          热门排行
        </h2>
        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''}`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.heat}</p>
              </div>
              <span className="px-2.5 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 font-label font-medium flex-shrink-0 whitespace-nowrap">
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}